import { ColorScale } from '.'

export const turquoise: ColorScale = {
  c10: '#002B26',
  c20: '#00443D',
  c30: '#005E55',
  c40: '#02786D',
  c50: '#1E8B7F',
  c60: '#36A094',
  c70: '#50BBAF',
  c80: '#9BE1D8',
  c90: '#DBF6F2',
  c100: '#FFFFFF',
}
